<template>
  <LmForm ref="lmFormRef">
    <LmComponentLoading v-show="isPageLoading" />
    <b-row no-gutters id="lm-user-profile" class="wrapper-content w-100">
      <b-col cols="12" class="wrapper-content">
        <b-row class="wrapper-title-page">
          <b-col cols="12" class="d-flex  align-items-center">
            <h4 class="page-title">{{ $t('user_profile_title') }}</h4>
          </b-col>
        </b-row>
        <b-row cols="12">
          <div class="col-12 justify-content-center d-flex">
            <b-popover
                ref="avatarPopover"
                target="avatar-user"
                triggers="click"
                placement="bottom"
              >
                <b-button variant="link" @click="showOnlyInputFileMethod">Subir una Imagen</b-button>
                <b-button v-if="browserSupportGetUserMedia" variant="link" @click="takePhoto">Tomar una foto</b-button>
            </b-popover>
            <div class="text-center wrapper-avatar">
              <b-avatar
                id="avatar-user"
                size="10rem"
                button
              >
                <img :src="form.avatar" class="avatar-user-img">
                <font-awesome-icon
                  class="camera-icon"
                  icon="camera-retro"
                  size="3x"
                  />
              </b-avatar>
              <h1 class="font-weight-bold mt-3 text-name">{{ username | lmCapitalizeFilter }}</h1>
            </div>
          </div>
        </b-row>
        <hr>
      </b-col>
      <b-row>
        <b-col cols="12">
          <h3>Datos Personales</h3>
        </b-col>
        <b-col cols="12" class="col-lg-2">
          <LmTextInput
            v-model="form.id"
            label="N legajo"
            type="number"
            :disabled="true"
            />
        </b-col>
        <b-col cols="12" class="col-lg-5">
          <LmTextInput
            v-model="form.extra.d_nombre"
            label="Nombre"
            :disabled="true"
            />
        </b-col>
        <b-col cols="12" class="col-lg-5">
          <LmTextInput
            v-model="form.extra.d_apellido"
            label="Apellido"
            :disabled="true"
            />
        </b-col>
        <b-col cols="12" class="col-lg-6">
          <LmTextInput
            v-model="form.extra.d_oficina"
            label="Oficina"
            :disabled="true"
            />
        </b-col>
        <b-col cols="12" class="col-lg-6">
          <LmTextInput
            v-model="form.extra.d_secretaria"
            label="Secretaria"
            :disabled="true"
            />
        </b-col>
        <b-col cols="12">
          <LmTextInput
            v-model="form.extra.d_email"
            label="Email"
            :disabled="true"
            />
        </b-col>
      </b-row>
      <b-col cols="12" v-if="showFirmaSection">
        <b-row>
          <b-col cols="12">
            <hr>
            <h3>Datos de la Firma</h3>
          </b-col>
          <b-col v-if="showFirmaImgSection" cols="12" class="col-lg-8">
            <b-row>
              <b-cols cols="12" class="col-lg-6">
                <div v-if="placeHolderFirmaImg">
                  <img
                    :src="placeHolderFirmaImg"
                    alt="Firma"
                    class="crop-img d-inline-block"
                    />
                </div>
              </b-cols>
              <b-cols cols="12" class="col-lg-6">
                <LmButton
                  id="btn-modificar-imagen-firma"
                  type="button"
                  buttonClass="btn-primary"
                  :isProcessing="isFormProcessing"
                  :value="$t('Modificar Imagen')"
                  v-b-modal.loadFirma
                  lmButtonRootWrapperClass="d-inline-block l-2"
                  lmButtonWrapperClass="col"
                />
              </b-cols>
            </b-row>
          </b-col>
          <b-col cols="12" class="col-lg-4">
            <LmTextInput
              v-model="form.extra.d_cargo"
              label="Cargo"
              :v="$v.form.extra.d_cargo"
              />
          </b-col>
          <b-col cols="12">
            <LmButton
              id="btn-previsualizar-firma"
              type="button"
              buttonClass="btn-success"
              :isProcessing="isFormProcessing"
              :value="$t('Previsualizar Firma')"
              @click.native="previsualizarFirmaBtn"
              lmButtonRootWrapperClass="d-inline-block mt-1"
              lmButtonWrapperClass="col"
            />
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12">
        <hr>
        <LmButton
          id="btn-cancelar"
          type="button"
          buttonClass="btn-secondary"
          :isProcessing="isFormProcessing"
          :value="$t('Cancel')"
          @click.native="cancelBtn"
          lmButtonRootWrapperClass="d-inline-block mr-1 mt-1"
          lmButtonWrapperClass="col"
        />
        <LmButton
          id="btn-guardar"
          type="submit"
          buttonClass="btn-primary"
          :isProcessing="isFormProcessing"
          :value="$t('Save')"
          lmButtonRootWrapperClass="d-inline-block mr-1 mt-1"
          lmButtonWrapperClass="col"
          @click.native="submit"
          />
      </b-col>
    </b-row>
    <b-modal id="loadFirma" title="Cargar Firma" size="xl">
      <div id="image-for-signature-wrapper" class="row">
        <div class="col-12">
          <LmCropper
            ref="lmCropper"
            hideSaveButton
            hideCropButton
            hideCropImg
            imgToCropWidthAsContainer
            :aspectRatio="3/1"
            :minCropBoxWidth="300"
            :minCropBoxHeight="100"
            labelFile="Imagen de la firma"
            @imageCropperChanged="form.extra.i_firma = $event; closeLoadFirma()"
            :initialImageSrc="form.extra.i_firma"
            />
        </div>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100">
          <LmButton
            id="btn-crop-save"
            type="button"
            lmButtonRootWrapperClass="d-inline-block mr-1 mt-3"
            buttonClass="btn-primary"
            :value="$t('Save')"
            class="float-right"
            @click.native="crop"
          />
          <LmButton
            id="btn-crop-cancel"
            type="button"
            lmButtonRootWrapperClass="d-inline-block mr-1 mt-3"
            buttonClass="btn-secondary"
            :value="$t('Cancel')"
            class="float-right"
            @click.native="closeLoadFirma"
          />
        </div>
      </template>
    </b-modal>
    <b-modal id="loadAvatar" :title="loadAvatarModalTitle" size="xl">
      <div class="col-12 justify-content-center d-flex" v-if="!imageToCrop && !mustShowOnlyInputFileMethod">
        <LmCapturePhoto
          @imageChanged="form.avatar = $event"
          @capture="loadImageToCrop"
          ref="lmCapturePhoto"
        />
      </div>
      <div v-show="mustShowOnlyInputFileMethod || imageToCrop" id="image-for-avatar-wrapper" class="row">
        <div class="col-12">
          <LmCropper
            ref="lmCropperAvatar"
            hideSaveButton
            hideCropButton
            hideCropImg
            imgToCropWidthAsContainer
            :aspectRatio="1/1"
            :minCropBoxWidth="300"
            :minCropBoxHeight="300"
            :viewMode="1"
            labelFile="Imagen Avatar"
            @imageCropperChanged="form.avatar = $event; closeLoadAvatar()"
            @imageLoadedToBeCrop="isImageLoadedToBeCrop = true"
            @reset="isImageLoadedToBeCrop = false"
            :initialImageSrc="form.avatar"
            :imgSrc="imageToCrop"
            />
        </div>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100">
          <LmButton
            :disabled="!isImageLoadedToBeCrop"
            id="btn-crop-save-avatar"
            type="button"
            lmButtonRootWrapperClass="d-inline-block mr-1 mt-3"
            buttonClass="btn-primary"
            :value="$t('Save')"
            class="float-right"
            @click.native="cropAvatar"
          />
          <LmButton
            id="btn-crop-cancel-avatar"
            type="button"
            lmButtonRootWrapperClass="d-inline-block mr-1 mt-3"
            buttonClass="btn-secondary"
            :value="$t('Cancel')"
            class="float-right"
            @click.native="closeLoadAvatar"
          />
        </div>
      </template>
    </b-modal>
    <b-modal id="previewFirmaModal" title="Previsualizador" size="xl" hide-footer>
      <iframe v-if="filePreviewPath" :src="filePreviewPath" frameborder="0" style="height:75vh;" width="100%"></iframe>
    </b-modal>
  </LmForm>
</template>

<script>
import axios from 'axios'
import { mapState, mapActions } from 'vuex'
import SessionAuthService from '@/auth/SessionAuthService'
import LmCapturePhoto from '@/components/LmCapturePhoto.vue'
import LmCropper from '@/components/LmCropper.vue'
import LmButton from '@/components/form/elements/LmButton'
import LmForm from '@/components/form/LmForm.vue'
import lmToasts from '@/mixins/lmToasts.js'
import LmTextInput from '@/components/form/elements/LmTextInput'
import { required, requiredIf } from 'vuelidate/lib/validators'

export default {
  mixins: [lmToasts],
  computed: {
    ...mapState('session', ['username', 'extra']),
    placeHolderFirmaImg () {
      return this.form.extra.i_firma || ''
    },
    showFirmaSection () {
      return !!this.form?.extra?.sections?.showFirmaSection
    }
  },
  data () {
    return {
      showFirmaImgSection: false,
      loadAvatarModalTitle: '',
      browserSupportGetUserMedia: 'getUserMedia' in navigator.mediaDevices,
      isImageLoadedToBeCrop: false,
      isPageLoading: true,
      isFormProcessing: true,
      filePreviewPath: false,
      imageToCrop: '',
      mustShowOnlyInputFileMethod: false,
      form: {
        avatar: '',
        extra: {}
      }
    }
  },
  validations: {
    form: {
      avatar: {
        required
      },
      extra: {
        d_cargo: {
          required: requiredIf(function () {
            return this.form.extra.sections.showFirmaSection
          })

        }
      }
    }
  },
  components: {
    LmForm,
    LmCapturePhoto,
    LmButton,
    LmCropper,
    LmTextInput
  },
  methods: {
    ...mapActions('commons', ['updateItemDetail']),
    ...mapActions('session', ['getUserInfo']),
    loadImageToCrop (dataUrl) {
      this.$refs.lmCropperAvatar.replace(dataUrl)
      this.imageToCrop = dataUrl
    },
    showOnlyInputFileMethod () {
      this.loadAvatarModalTitle = 'Agregar una imagen para el Avatar'
      this.$refs.avatarPopover.$emit('close')
      this.$bvModal.show('loadAvatar')
      this.mustShowOnlyInputFileMethod = true
    },
    crop () {
      this.$refs.lmCropper.crop()
      this.$refs.lmCropper.submit()
    },
    cropAvatar () {
      this.$refs.lmCropperAvatar.crop()
      this.$refs.lmCropperAvatar.submit()
    },
    closeLoadFirma () {
      this.$bvModal.hide('loadFirma')
    },
    closeLoadAvatar () {
      this.$bvModal.hide('loadAvatar')
      this.imageToCrop = ''
      this.$refs.lmCropperAvatar.reset()
    },
    async takePhoto () {
      this.loadAvatarModalTitle = 'Tomar una foto para el Avatar'
      this.$bvModal.show('loadAvatar')
      this.$refs.avatarPopover.$emit('close')
      this.mustShowOnlyInputFileMethod = false
      this.$nextTick(() => {
        this.$refs.lmCapturePhoto.getUserMedia()
      })
    },
    async submit () {
      try {
        this.isFormProcessing = true
        await this.$refs.lmFormRef.validationForm(this.$v)
        const dataToSendToTheServer = {
          d_cargo: this.form.extra.d_cargo,
          avatar: this.form.avatar,
          i_firma: this.form.extra.i_firma
        }
        let apiUrl = `${process.env.VUE_APP_API_URL}usuarios/`
        let response = await this.updateItemDetail({
          path: apiUrl,
          data: dataToSendToTheServer
        })

        if (response.id) {
          this.lmToastSuccessInternalLink(`/user-profile`, 'Ver Detalle', 'Gracias por Actualizar tu perfil')
          this.getUserInfo()
        }
        this.$router.go(-1)
      } finally {
        this.isFormProcessing = false
      }
    },
    previsualizarFirmaBtn () {
      this.isFormProcessing = true
      axios.get('/decretos/firma/preview', {
        params: {
          d_cargo: this.form.extra.d_cargo,
          i_firma: this.form.extra.i_firma
        }
      })
        .then(response => {
          this.filePreviewPath = response?.data?.url ? response.data.url : false
          this.$bvModal.show('previewFirmaModal')
        })
        .catch(error => {
          throw error
        })
        .finally(() => {
          this.isFormProcessing = false
        })
    },
    cancelBtn () {
      this.$router.go(-1)
    }
  },
  async mounted () {
    try {
      this.auth = new SessionAuthService()
      this.form = await this.auth.getUserInfo()
    } finally {
      this.isFormProcessing = false
    }
    this.isPageLoading = false
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      document.title = `Perfil ${vm.username} ${vm.$store.getters['settings/appName']} `
    })
  }
}
</script>

<style lang="sass" scoped>
  #lm-user-profile
    .wrapper-avatar
      #avatar-user
        .avatar-user-img
          max-height: 100%
        .camera-icon
          position: absolute
          bottom: 20px
      .text-name
        font-size: 22px
  .crop-img
    max-width: 300px
    max-height: 100px
</style>
